<template>
  <div class="task-box">
    <el-form :model="ruleForm" :hide-required-asterisk="true" label-width="80px" size="mini" label-position="right" ref="ruleForm">
      <el-row :gutter="20">
        <el-col :span="1" style="margin-right:15px">
          <el-form-item prop="titleCheck" label-width="0px">
            <el-checkbox v-model="ruleForm.titleCheck"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="21">
          <el-form-item prop="taskTitle" label-width="0px">
            <el-input v-model="ruleForm.taskTitle" maxlength="50" placeholder="请输入任务标题"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="value2" label-width="0px">
            <el-select v-model="ruleForm.value2" multiple collapse-tags placeholder="选择执行人">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="value3" label-width="0px">
            <el-select v-model="ruleForm.value3" multiple collapse-tags placeholder="添加参与人">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="date2" label-width="0px">
            <el-date-picker v-model="ruleForm.date2" align="right" type="date" placeholder="添加截至日期" :picker-options="shortcuts">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="value3" label-width="0px">
            <el-select v-model="ruleForm.value3" placeholder="优先级">
              <el-option v-for="item in taskLevelMap" :style="{'color':item.color}" :key="item.key" :label="item.name" :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item prop="value3" label-width="0px">
          <el-input type="textarea" :rows="8" placeholder="请输入任务描述" v-model="ruleForm.textarea2">
          </el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <div class="file-box">
          <div class="file-box-icon"><i class="el-icon-paperclip"></i></div>
          <el-upload class="upload-demo" action=" string" :on-change="handleChange" :file-list="fileList">
            <el-link type="primary">添加附件</el-link>
            <!-- <el-button size="small" type="primary">点击上传</el-button> -->
          </el-upload>

        </div>
      </el-row>
      <el-row style="margin-top:17px;">
        <div class="child-task"><i class="el-icon-share"></i><span>子任务</span></div>
      </el-row>
      <div v-for="(item,index) in childTaskJson" :key="index">
        <el-row :gutter="20" class="child-task-title">
          <el-col :span="2">
            <el-form-item prop="checked" label-width="0px">
              <el-checkbox v-model="childTaskJson[index].checked"></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item prop="title" label-width="0px">
              <el-input v-model="childTaskJson[index].title" maxlength="50" placeholder="子任务标题"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="child-task-title-rest">
          <el-col :span="12">
            <el-form-item prop="time" label-width="0px">
              <el-date-picker v-model="childTaskJson[index].time" align="right" type="date" placeholder="添加截至日期" :picker-options="shortcuts">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="const" label-width="0px">
              <el-select v-model="childTaskJson[index].const" multiple collapse-tags placeholder="添加参与人">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-row class="add-new-task">
        <div class="child-task" @click="addChildTask"><i class="el-icon-circle-plus"></i><span>添加子任务</span></div>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { taskLevelMap } from '@/utils/const.js'
export default {
  props: {
    dataset: {
      type: Object,
      defalut: () => { }
    }
  },
  data() {
    return {
      ruleForm: {
        checked: false,
        title: '',
        textarea2: '',
        value2: '',
        date2: '',
        textarea2: '',
        free: ''
      },
      taskLevelMap: taskLevelMap,
      memberList: [],
      options: [],
      childTaskJson: [{
        checked: false,
        title: '',
        time: '',
        const: ''
      }],
      fileList: []
    }
  },
  computed: {
    ...mapState('layout/layout', ['shortcuts'])
  },
  methods: {
    tileData(dataList) {
      let arr = [];
      dataList.forEach(item => {
        arr = [...arr, ...item.member];
      });
      return arr;
    },
    addChildTask() {
      this.childTaskJson.push({
        checked: false,
        title: '',
        time: '',
        const: ''
      })
    },
    handleChange(file, fileList) {
      this.fileList.push({ name: file.name })
    }
  }
}
</script>
<style lang="scss">
.task-box {
  color: initial;
  .row-line {
    display: flex;
    align-items: center;
  }
  .file-box {
    display: flex;
    font-size: 14px;
  }
  .file-box-icon {
    font-size: 16px;
    margin-right: 17px;
  }
  .child-task {
    display: flex;
    font-size: 14px;
    align-items: center;
    i {
      font-size: 16px;
      margin-right: 17px;
    }
  }
  .child-task-title {
    margin-top: 15px;
    padding-left: 35px;
  }
  .child-task-title-rest {
    padding-left: 80px;
  }
  .el-checkbox__inner {
    width: 20px;
    height: 20px;
    border-radius: 50%;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #00b97e;
    border-color: #00b97e;
  }
  .el-icon-circle-plus {
    color: #509aff;
  }
  .add-new-task {
    cursor: pointer;
    height: 40px;
    line-height: 40px;
    width: 150px;
    text-align: center;
    &:hover {
      color: #509aff;
    }
    .el-icon-circle-plus {
      font-size: 22px;
    }
  }
  .tip {
    font-size: 16px;
    margin-top: 22px;
    margin-bottom: 28px;
    // font-weight: bold;
  }
  .el-checkbox__inner::after {
    height: 7px;
    left: 7px;
    top: 4px;
  }
  .el-input__inner {
    height: 40px;
    font-size: 12px;
    background-color: #f8f9fb;
  }
  .el-form-item--mini .el-form-item__content {
    line-height: 40px;
  }
  .el-icon-arrow-up:before {
    content: "\e78f";
  }
}
.el-drawer__body {
  height: 100%;
  overflow: auto;
}
</style>
